import { Log } from '@core';
import { Observable, of } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import { VersionConfigSyncService } from '@update/infra';

export class VersionConfigSyncStep extends StartupStep {
  private readonly versionConfigSyncService: VersionConfigSyncService = inject(VersionConfigSyncService);

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'VersionConfigSyncStep START' });

    this.versionConfigSyncService.startSync();

    this.logger.log(Log.Startup, { message: 'VersionConfigSyncStep COMPLETED' });
    return of(state);
  }
}
